module.exports = __webpack_public_path__ + "img/40_69_003_950.f1f3ba46.jpg";